"use strict";

let connectionStatus = "online";
let events = {};
let mushroom;
let app_id = window.MyConfig.applicationId;
let env = window.MyConfig.env;

function MushroomError(code, subCode, detail, meta, result, message) {
    if (message === undefined)
        message = detail;

    const instance = new Error(message);
    instance.name = "MushroomError";
    instance.code = code;
    instance.subCode = subCode;
    instance.detail = detail;
    instance.meta = meta;
    instance.result = result;
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    if (Error.captureStackTrace) {
        Error.captureStackTrace(instance, MushroomError);
    }
    return instance;
}

MushroomError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: Error,
        enumerable: false,
        writable: true,
        configurable: true
    }
});

if (Object.setPrototypeOf) {
    Object.setPrototypeOf(MushroomError, Error);
} else {
    MushroomError.__proto__ = Error;
}


async function fireEvent(eventName, args) {
    if (typeof eventName !== "string") throw new Error("eventName must be a string");
    if (eventName === "") throw new Error("eventName cannot be empty");

    if (!events[eventName])
        return;

    for (let i=0; i<events[eventName].length; i++){
        const evt = events[eventName][i];
        const r = evt.apply(mushroom, args === undefined ? [] : args);
        if (r instanceof Promise)
            await r;
    }
}

function findManyUrlGenerator(config) {
    return function(settings) {
        let base = mushroom._fnGetRootApiUrl("findMany") + config.name + "s/";
        if (settings === null || typeof settings !== "object")
            return base;

        var parameters = [];

        if (settings.filters) {
            if (typeof settings.filters === "string")
                parameters.push(settings.filters);
            else if (Array.isArray(settings.filters)) {
                settings.filters.forEach(function(item) {
                    parameters.push(item);
                });
            }
        }

        if (settings.fields) {
            if (typeof settings.fields === "string")
                parameters.push("$fields=" + encodeURIComponent(settings.fields));
            else if (Array.isArray(settings.fields))
                parameters.push("$fields=" +
                    settings.fields.map(function(item) { return encodeURIComponent(item); }).join(","));
        }

        if (settings.sort) {
            if (typeof settings.sort === "string")
                parameters.push("$sort=" + encodeURIComponent(settings.sort));
            else if (Array.isArray(settings.sort))
                parameters.push("$sort=" +
                    sort.sort.map(function(item) { return encodeURIComponent(item); }).join(","));
        }

        if (typeof settings.limit === "number") {
            parameters.push("$limit=" + settings.limit);
        }

        if (typeof settings.offset === "number") {
            parameters.push("$offset=" + settings.offset);
        }

        if (typeof settings.page === "number") {
            parameters.push("$page=" + settings.page);
        }

        if (typeof settings.vn_text === "string") {
            parameters.push("$vn_text=" + settings.vn_text);
        }

        if (parameters.length) {
            base += "?" + parameters.join("&");
        }

        return base;
    };
}

function findByIdUrlGenerator(config) {
    return function(settings) {
        if (settings.id === null || settings.id === undefined || settings.id === "")
            throw new ReferenceError("findById thiếu id");

        let base = mushroom._fnGetRootApiUrl("findById") + config.name + "s/" + settings.id;

        const parameters = [];

        if (settings.fields) {
            if (typeof settings.fields === "string")
                parameters.push("$fields=" + encodeURIComponent(settings.fields));
            else if (Array.isArray(settings.fields))
                parameters.push("$fields=" +
                    settings.fields.map(function(item) { return encodeURIComponent(item); }).join(","));
        }

        if (parameters.length) {
            base += "?" + parameters.join("&");
        }

        return base;
    };
}

function resourceUrlGenerator(config) {
    return function(settings) {
        return mushroom._fnGetRootApiUrl("resourceUrl") + config.name + "s/";
    };
}

function resourceIdUrlGenerator(config) {
    return function (settings, data) {
        let id = settings ? settings.id : undefined;
        if (id === null || id === undefined || id === "")
            id = data ? data.id : undefined;

        if (id === null || id === undefined || id === "")
            throw new ReferenceError("Missing id");
        return mushroom._fnGetRootApiUrl("resourceIdUrl") + config.name + "s/" + id;
    };
}

function toQueryString(obj, path) {
    if (obj === null || obj === undefined || typeof obj === "function")
        return "";

    if (typeof obj === "string")
        return encodeURIComponent(obj);
    if (typeof obj === "number" || typeof obj === "boolean")
        return obj;

    if (Array.isArray(obj))
        return obj.map(function (item) {
            return toQueryString(item, path);
        }).join(",");

    const arr = [];
    for (let m in obj) {
        if (!obj.hasOwnProperty(m))
            continue;

        const key = (path ? path : "") + m;
        arr.push(key + "=" + toQueryString(obj[m], key));
    }
    return arr.join("&");
}

function entityViewUrlGenerator(config, viewName) {
    return function (settings) {
        const base = mushroom._fnGetRootApiUrl("entityViewUrl") + config.name + "s/views/" + viewName;
        if (settings === null || typeof settings !== "object")
            return base;

        const queryString = toQueryString(settings);

        return queryString ? base + "?" + queryString : base;
    };
}

function viewUrlGenerator(config) {
    return function (settings) {
        const base = mushroom._fnGetRootApiUrl("viewUrl") + "view/" + config.name;
        if (settings === null || typeof settings !== "object")
            return base;

        const queryString = toQueryString(settings);

        return queryString ? base + "?" + queryString : base;
    };
}

let cache = {};
let cache_age = 0; // 5 phút

function createAsyncRestfulFunction(config) {
    return function(dataOrSettings, settings) {
        return new Promise(async (resolve, reject) => {
            if (config.blankBody) {
                settings = dataOrSettings;
            }

            if (settings === null || settings === undefined)
                settings = {};

            let request = {
                action: config.name,
                resource: config.resource,
                method: config.method,
                url: typeof config.url === "function" ? config.url(settings, dataOrSettings) : config.url,
                context: settings.context,
                data: config.blankBody ? undefined : dataOrSettings,
                isRawData: config.isRawData,
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    app_id,
                    env
                },
                events: settings.events,
                timeout: settings.timeout,
                enabledCache: config.method && config.method.toUpperCase() === "GET" && (settings.enabledCache || settings.enabledCache === undefined && config.enabledCache),
                cacheAge: settings.cacheAge || config.cacheAge || cache_age
            };

            await fireEvent("beginRequest",
            [
                {
                    request: request
                }
            ]);
            
            await fireEvent("beforeSend", [request]);
            
            if (typeof config.beforeSend === "function") {
                await config.beforeSend(request, settings, dataOrSettings);
            }

            if (request.enabledCache) {
                if (request.url in cache) {
                    const cacheItem = cache[request.url];
                    console.log("found in cache: ", cacheItem);

                    if (new Date().getTime() - cacheItem.t > cache_age) {
                        console.log("... but out of date, ignore cache");
                        delete cache[request.url];
                    } else {
                        const data = JSON.parse(cacheItem.o);
                        resolve(data);

                        try {
                            fireEvent("endRequest",
                                [
                                    {
                                        response: data,
                                        request: request,
                                        cache: cacheItem
                                    }
                                ]);
                        } catch (ex) {
                            console.log("Error in endRequest: ", ex);
                        }

                        return;
                    }
                }
            }

            var x = new XMLHttpRequest();
            x.open(request.method, request.url, true);

            if (config.headers !== null && typeof config.headers === "object") {
                for (var name in config.headers) {
                    if (config.headers.hasOwnProperty(name)) {
                        request.headers[name] = config.headers[name];
                    }
                }
            }
            
            for (var headerName in request.headers) {
                if (request.headers.hasOwnProperty(headerName)) {
                    x.setRequestHeader(headerName, request.headers[headerName]);
                }
            }
            
            
            if (request.timeout)
                x.timeout = request.timeout;
            else if (mushroom._requestTimeout)
                x.timeout = mushroom._requestTimeout;


            x.onreadystatechange = function() {
                //console.log("onreadystatechange, readyState=", this.readyState);
                if (this.readyState !== 4) return;

                //console.log(this.responseText);

                if (this.status === 0) {
                    // aborted, error, timeout
                    return;
                }

                if (connectionStatus !== "online") {
                    connectionStatus = "online";
                    fireEvent("online");
                }

                var data;
                var ex;
                try {
                    data = JSON.parse(this.responseText);
                } catch (e) {
                    console.log("Invalid response format");
                    const me = new MushroomError(5, 0, "Invalid response format");
                    reject(me);
                    try {
                        fireEvent("endRequest",
                            [
                                {
                                    error: me,
                                    request: request
                                }
                            ]);
                    } catch (ex) {
                        console.log("Error in endRequest: ", ex);
                    }
                    return;
                }

                if (data.code) {
                    //console.log("API error");
                    const mushroomError = new MushroomError(data.code, data.subCode, data.detail, data.meta, data.result);
                    reject(mushroomError);
                    try {
                        fireEvent("endRequest",
                            [
                                {
                                    error: mushroomError,
                                    request: request
                                }
                            ]);
                    } catch (ex) {
                        console.log("Error in endRequest: ", ex);
                    }
                    return;
                }

                if (config.clearCache) {
                    for (let url in cache) {
                        if (cache.hasOwnProperty(url)) {
                            if (cache[url].r === request.resource) {
                                delete cache[url];
                            }
                        }
                    }
                }

                if (request.enabledCache) {
                    delete cache[request.url];
                    cache[request.url] = {
                        i: JSON.stringify(request.data), // input
                        o: this.responseText, // output
                        t: new Date().getTime(),
                        r: request.resource
                    };
                }

                resolve(data);

                try {
                    fireEvent("endRequest",
                        [
                            {
                                response: data,
                                request: request
                            }
                        ]);
                } catch (ex) {
                    console.log("Error in endRequest: ", ex);
                }
                /*if (debugMode && window.mushroom._warning_slow_connection) {
                    var ms = new Date().getTime() - startTime.getTime();
                    if (ms >= 2000) {
                        console.warn("Slow response: " + ms + "ms\nStackTrace:\n" + stacktrace);
                    }
                }*/
            };
            x.addEventListener("timeout",
                () => {
                    console.log("Connection timeout");
                    var me = new MushroomError(2, 0, "Connection timeout");
                    reject(me);
                    try {
                        fireEvent("endRequest",
                            [
                                {
                                    error: me,
                                    request: request
                                }
                            ]);
                    } catch (ex) {
                        console.log("Error in endRequest: ", ex);
                    }
                });
            x.addEventListener("abort",
                () => {
                    console.log("Connection aborted");
                    var me = new MushroomError(3, 0, "Connection aborted");
                    reject(me);
                    try {
                        fireEvent("endRequest",
                            [
                                {
                                    error: me,
                                    request: request
                                }
                            ]);
                    } catch (ex) {
                        console.log("Error in endRequest: ", ex);
                    }
                });
            x.addEventListener("error",
                () => {
                    console.log("Connection error");
                    if (connectionStatus !== "offline") {
                        connectionStatus = "offline";
                        fireEvent("offline");
                    }
                    var me = new MushroomError(4, 0, "Connection error");
                    reject(me);
                    try {
                        fireEvent("endRequest",
                            [
                                {
                                    error: me,
                                    request: request
                                }
                            ]);
                    } catch (ex) {
                        console.log("Error in endRequest: ", ex);
                    }
                });

            if (request.events !== null && typeof request.events === "object") {
                for (var eventName in request.events) {
                    if (request.events.hasOwnProperty(eventName) && typeof request.events[eventName] === "function") {
                        x.addEventListener(eventName, request.events[eventName]);
                    }
                }
            }

            console.log("send request: ", request.method, request.url, request.headers, request.data);

            if (typeof config.processData === "function")
                request.data = config.processData(request.data, request, settings);

            x.send(request.data !== undefined && request.data !== null ? request.isRawData ? request.data : JSON.stringify(request.data) : null);
            
            //console.log("sent request");
        });
    };
}

var _rootApiUrl = null;

mushroom = {
    _defineAsyncResource: function(config) {
        if (!config || typeof config !== "object")
            throw new TypeError("config must be an object");
        if (typeof config.name !== "string")
            throw new TypeError("config.name must be a string");
        if (config.name === "")
            throw new TypeError("config.name cannot be a empty string");

        //window.resources[config.name.charAt(0).toString().toUpperCase() + config.name.substr(1)] = function () { };

        mushroom[config.name] = mushroom[config.name] || {};

        if (config.actions !== null && typeof config.actions === "object") {
            for (var actionName in config.actions) {
                if (!config.actions.hasOwnProperty(actionName))
                    continue;

                if (actionName === "findMany")
                    mushroom[config.name].listAsync = createAsyncRestfulFunction({
                        name: "listAsync",
                        resource: config.name,
                        method: "GET",
                        url: findManyUrlGenerator(config),
                        blankBody: true,
                        enabledCache: config.actions[actionName].clientCache
                    });
                else if (actionName === "findById")
                    mushroom[config.name].findByIdAsync = createAsyncRestfulFunction({
                        name: "findByIdAsync",
                        resource: config.name,
                        method: "GET",
                        url: findByIdUrlGenerator(config),
                        blankBody: true,
                        enabledCache: config.actions[actionName].clientCache
                    });
                else if (actionName === "createOne")
                    mushroom[config.name].createAsync = createAsyncRestfulFunction({
                        name: "createAsync",
                        resource: config.name,
                        method: "POST",
                        url: resourceUrlGenerator(config),
                        blankBody: false,
                        clearCache: true
                    });
                else if (actionName === "createMany")
                    mushroom[config.name].batchCreateAsync = createAsyncRestfulFunction({
                        name: "batchCreateAsync",
                        resource: config.name,
                        method: "POST",
                        headers: {
                            "X-Mushroom-Create-Many": "true"
                        },
                        url: resourceUrlGenerator(config),
                        blankBody: false,
                        clearCache: true
                    });
                else if (actionName === "updateOne")
                    mushroom[config.name].updateAsync = createAsyncRestfulFunction({
                        name: "updateAsync",
                        resource: config.name,
                        method: "PUT",
                        url: resourceIdUrlGenerator(config),
                        blankBody: false,
                        clearCache: true
                    });
                else if (actionName === "updateMany")
                    mushroom[config.name].batchUpdateAsync = createAsyncRestfulFunction({
                        name: "batchUpdateAsync",
                        resource: config.name,
                        method: "PUT",
                        url: resourceUrlGenerator(config),
                        blankBody: false,
                        clearCache: true
                    });
                else if (actionName === "updatePartially")
                    mushroom[config.name].partialUpdateAsync = createAsyncRestfulFunction({
                        name: "partialUpdateAsync",
                        resource: config.name,
                        method: "PATCH",
                        url: resourceIdUrlGenerator(config),
                        blankBody: false,
                        clearCache: true
                    });
                else if (actionName === "deleteOne")
                    mushroom[config.name].deleteAsync = createAsyncRestfulFunction({
                        name: "deleteAsync",
                        resource: config.name,
                        method: "DELETE",
                        url: resourceIdUrlGenerator(config),
                        blankBody: true,
                        clearCache: true
                    });
                else if (actionName === "deleteMany")
                    mushroom[config.name].batchDeleteAsync = createAsyncRestfulFunction({
                        name: "batchDeleteAsync",
                        resource: config.name,
                        method: "DELETE",
                        url: resourceUrlGenerator(config),
                        blankBody: false,
                        clearCache: true
                    });
            }
        }

        if (config.views !== null && typeof config.views === "object") {
            for (var viewName in config.views) {
                if (!config.views.hasOwnProperty(viewName))
                    continue;

                mushroom[config.name].views = mushroom[config.name].views || {};

                mushroom[config.name].views[viewName + "Async"] = createAsyncRestfulFunction({
                    name: "$views." + viewName,
                    resource: config.name,
                    method: "GET",
                    url: entityViewUrlGenerator(config, viewName),
                    blankBody: true
                });
            }
        }
    },
    _defineAsyncView: function (config) {
        if (!config || typeof config !== "object")
            throw new TypeError("config must be an object");
        if (typeof config.name !== "string")
            throw new TypeError("config.name must be a string");
        if (config.name === "")
            throw new TypeError("config.name cannot be a empty string");

        mushroom.$view[config.name] = createAsyncRestfulFunction({
            name: "$view",
            resource: config.name,
            method: "GET",
            url: viewUrlGenerator(config),
            blankBody: true,
            meta: config.views[config.name]
        });
    },
    _on: function (eventName, fnHandler) {
        if (typeof (eventName) !== "string") throw new Error("eventName must be a string");
        if (eventName === "") throw new Error("eventName cannot be empty");
        if (typeof (fnHandler) !== "function") throw new Error("fnHandler must be a callback function");

        var eventList = events[eventName];
        if (!eventList) eventList = events[eventName] = new Array();
        eventList.push(fnHandler);
        return this;
    },
    _unbindEvent: function (eventName, fnHandler) {
        if (typeof (eventName) !== "string") throw new Error("eventName must be a string");
        if (eventName === "") throw new Error("eventName cannot be empty");
        if (typeof (fnHandler) !== "function" && fnHandler !== undefined) throw new Error("fnHandler must be a callback function");

        var eventList = events[eventName];
        if (!eventList) return;
        if (fnHandler === undefined) {
            eventList.length = 0;
            return;
        }
        var idx = eventList.indexOf(fnHandler);
        if (idx !== -1) eventList.splice(idx, 1);
        return;
    },
    _hasEvent: function (eventName) {
        return eventName in events && events[eventName].length;
    },
    _fnGetRootApiUrl: function() {
        return mushroom.$using();
    },
    __createAsyncRestFunction: createAsyncRestfulFunction,
    $using: function (rootApiUrl) {
        if (rootApiUrl === undefined)
            return _rootApiUrl;
        _rootApiUrl = rootApiUrl;
        return this;
    },
    $view: {},
    $cache: {
        invalid: function(url) {
            if (url === undefined) {
                console.log("Invalid all cache");
                cache = {};
                return;
            }

            if (typeof url === "string") {
                console.log("Invalid cache: " + url);
                delete cache[url];
                return;
            }

            if (url instanceof RegExp) {
                console.log("Invalid cache by pattern " + url);

                for (let m in cache) {
                    if (cache.hasOwnProperty(m)) {
                        if (url.test(m)) {
                            console.log("Invalid cache: " + m);
                            delete cache[url];
                        }
                    }
                }

                return;
            }

            console.warn("Unknown type of parameter: ", url);
        },
        setCacheAge: function(ms) {
            if (ms <= 0)
                throw new RangeError();

            cache_age = ms;
        }
    },
    MushroomError: MushroomError
};

export default mushroom;